"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterPaymentMethodItemToJSON = exports.FooterPaymentMethodItemFromJSONTyped = exports.FooterPaymentMethodItemFromJSON = exports.instanceOfFooterPaymentMethodItem = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the FooterPaymentMethodItem interface.
 */
function instanceOfFooterPaymentMethodItem(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFooterPaymentMethodItem = instanceOfFooterPaymentMethodItem;
function FooterPaymentMethodItemFromJSON(json) {
    return FooterPaymentMethodItemFromJSONTyped(json, false);
}
exports.FooterPaymentMethodItemFromJSON = FooterPaymentMethodItemFromJSON;
function FooterPaymentMethodItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': !(0, runtime_1.exists)(json, 'title') ? undefined : json['title'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'icon': !(0, runtime_1.exists)(json, 'icon') ? undefined : json['icon'],
    };
}
exports.FooterPaymentMethodItemFromJSONTyped = FooterPaymentMethodItemFromJSONTyped;
function FooterPaymentMethodItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
        'url': value.url,
        'icon': value.icon,
    };
}
exports.FooterPaymentMethodItemToJSON = FooterPaymentMethodItemToJSON;
